export { default } from './PagePlacesCategories.vue'
